<template>
  <div class="container-fluid">
    <div v-if="type == 'add'">
      <form v-on:submit.prevent>
        <div class="form-group row">
          <label class="col-sm-3 col-form-label">Instacart Account Name <sup>*</sup></label>
          <div class="col-sm-5 pr-5">
            <multiselect
              name="instacart"
              :options="instacartList"
              label="instacart_profile_name"
              v-model="profile.selected_profile"
              track-by="instacart_profile_id"
              class="form-control select_filter"
              id="advertiser"
              placeholder="Instacart Account Name"
              autocomplete="off"
              style="height: 41px"
              
              @select="instacartChanged"
            />
          </div>
          <div class="col-md-2">
            <button
              class="btn btn-primary"
              style="font-size: 12px"
              @click="addNewInstacart()"
            >
              Create New
            </button>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-3 col-form-label"> Instacart Profile ID <sup>*</sup></label>
          <div class="col-sm-7 pr-5">
            
            <input
              type="text"
              name="advertiser_id"
              v-model="profile.selected_profile.instacart_profile_id"
              class="form-control"
              id="advertiser_id"
              placeholder="Instacart Profile ID"
              autocomplete="off"
              style="height: 40px"
              v-on:input="checkProfileDuplicasy($event)"
            />
            <p
								class="no-data-style"
                style="height:10px"
							>
              {{profile.duplicateProfile?'Instacart with same id already exist, please choose another.':''}}
            </p>
          </div>
        </div>
        <div class="form-group row" style="padding-left: 0px">
          <div class="col-sm-3 col-form-label">
            <label class="form-check-label" for="exampleCheck1">Active</label>
          </div>
          <div
            class="col-form-label"
            style="margin-left: 15px; margin-right: 30px"
          >
            <div
              class="form-check d-inline-block"
              style="display: flex !important"
            >
              <input
                type="checkbox"
                v-model="profile.active"
                :disabled="
                  profile.active &&
                  profile.disable_date != '' &&
                  profile.disable_date != null
                "
                value="true"
                style="padding-bottom: 5px"
                class="form-check-input"
                id="exampleCheck1"
                autocomplete="off"
                @click="activeValueChange($event)"
              />
            </div>
          </div>
          <div
            class="col-sm-7 form-group"
            v-if="profile.showDate"
            style="padding: 0px"
          >
            <div class="form-group col" style="padding: 0px">
              <div class="form-group row" style="margin: 0px">
                <div
                  class="col-form-label align-self-center"
                  style="
                    padding-top: 0px;
                    margin: 0px;
                    padding: 0px;
                    margin-top: 0px;
                  "
                  :style="
                    ifDisabledOnPastDate(profile.disable_date)
                      ? 'margin-top:5px'
                      : 'margin-top:-4px'
                  "
                >
                  <label class="form-check-label" for="exampleCheck1">{{
                    ifDisabledOnPastDate(profile.disable_date)
                      ? "Disabled On " + getFormattedDate(profile.disable_date)
                      : "Disables On"
                  }}</label>
                </div>
                <div class="col-sm-5" style="padding-top: 0px">
                  <b-form-datepicker
                    :id="index + '_disable'"
                    name="disable_date"
                    placeholder="MM/DD/YYYY"
                    class="date_wrapper"
                    v-model="profile.disable_date"
                    menu-class="w-100"
                    size="sm"
                    :date-format-options="{
                      day: '2-digit',
                      month: '2-digit',
                      year: 'numeric',
                    }"
                    calendar-width="180%"
                    :hide-header="true"
                    :today-button="false"
                    :min="min_date_disable"
                    locale="en"
                    v-if="!ifDisabledOnPastDate(profile.disable_date)"
                    @input="updateTheValidation(-1)"
                  ></b-form-datepicker>
                </div>
                <div
                  class="col-sm-3"
                  style="margin: 0px; padding: 0px"
                  v-if="
                    !ifDisabledOnPastDate(profile.disable_date) &&
                    profile.disable_date &&
                    profile.active
                  "
                >
                  <button
                    class="btn btn-primary"
                    style="font-size: 12px"
                    @click="deleteDate"
                  >
                    Delete Date
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            class="col-sm-1"
            style="text-align: center"
            v-if="
              profile.showDate &&
              profile.disable_date &&
              !ifDisabledOnPastDate(profile.disable_date)
            "
          >
            <p style="font-size: 13px; color: orange">Pending InActive</p>
          </div>
        </div>

        <div
          class="row"
          style="padding-top: 10px"
          v-if="!ifDisabledOnPastDate(profile.disable_date) && profile.showDate"
        >
          <div class="msg-style">
            <p class="msg-text-style" style="">
              {{ "Update will happen at 11:59pm on selected date" }}
            </p>
          </div>
        </div>
        <div
          class="no-data-style row"
          style="padding-top: 10px; margin-left: 15px"
          v-if="index == noDateForActiveFalse && profile.showDate"
        >
          Provide Date to disable the profile
        </div>
        
        <!-- <div class="form-group row">
          <label class="col-sm-3 col-form-label">
            </label>
          <div class="col-sm-7 pr-5">
            <p class="no-data-style" v-if="true || profile.duplicateProfile">
              Instacart with same id already exist, please choose another.
            </p>
          </div>
        </div> -->
      </form>
    </div>
  </div>
</template>
<script>
import moment from "moment";

import datePicker from "vue-bootstrap-datetimepicker";
import Multiselect from "vue-multiselect";
export default {
  components: {
    datePicker,
    Multiselect,
  },
  name: "InstacartAccountData",
  props: [
    "instacartList",
    "profile",
    "index",
    "updateDisableDate",
    "noDateForActiveFalse",
    "type",
    "client_id",
    "instacart"
  ],
  data() {
    return {};
  },
  computed: {
    min_date_disable() {
      //only allow future dates, will prevent past as well as current date from selection
      return moment()
        .add(1, "days")
        .format("YYYY-MM-DD");
    }
  },
  methods: {
    moment,
    instacartChanged(e) {
      if (
        this.profile.type == "Instacart Accounts" &&
        Object.keys(this.profile.selected_profile).length
      ) {
        this.$emit('convertToUniqueInstaCartDataSet',
          this.profile.selected_profile.instacart_profile_id.trim(),
          'remove'
        );
      }

      this.profile?(this.profile.duplicateProfile = false):''
      let obj = {
        date: e.disable_date,
        index: this.index,
        selected: e,
        active:e.active,
        prev_go_client_id:e.go_client_id
      };
      this.$emit("instacartUpdated", obj);
    },
    activeValueChange(val) {
      if (!val.currentTarget.checked) {
        this.$emit("updateDisableDate", this.index, true);
      } else {
        this.$emit("updateDisableDate", this.index, false);
      }
    },
    ifDisabledOnPastDate(disableDate) {
      let x = moment(disableDate).isSameOrBefore(moment());
      return x;
    },
    getFormattedDate(date) {
      return moment(date).format("MM/DD/YYYY");
    },
    setDateFormat(date) {
      return moment().format("MM/DD/YYYY");
    },
    updateTheValidation(data) {
      this.$emit("dateProvideDisableVAlidation", data);
    },
    deleteDate() {
      this.$emit("removeDate", this.index);
    },
    addNewInstacart() {
      let indx = this.index;
      this.$emit("openInstacartPopUp", indx);
    },
    checkProfileDuplicasy(event) {
				let data = event.currentTarget.value;
				this.profile.duplicateProfile = false;
				let isPresent = this.instacartList.find(
					e =>
						e.instacart_profile_id &&
						e.instacart_profile_id.toLowerCase().trim() ==
							data.toLowerCase().trim() &&
						e.instacart_profile_name != this.profile.selected_profile.instacart_profile_name
				);

				if (isPresent) {
					this.profile.duplicateProfile = true;
				} else {
					this.profile.duplicateProfile = false;
				}
			}
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>